// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-76ffcc5a] h2{font-size:2rem;line-height:2.75rem;margin-bottom:1.5rem}[data-v-76ffcc5a] h2:not(:first-child){margin-top:4rem}[data-v-76ffcc5a] p{margin-bottom:1.5rem}[data-v-76ffcc5a] ol{padding-left:1.5rem}[data-v-76ffcc5a] ol li{margin-top:12px}[data-v-76ffcc5a] ol ol{padding-left:1rem}[data-v-76ffcc5a] ol>li>ol{list-style-type:lower-alpha}[data-v-76ffcc5a] ol>li>ol>li>ol{list-style-type:lower-roman}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
